import { matchPath } from "react-router-dom";

import type { AppState } from "./store";

export const getSearchString = (state: AppState) => state.router.location.search;

export interface RouteParams {
  pathOrganizationUuid: string;
  extraPath?: string;
}

export const getRouteOrgUuid = (state: AppState) =>
  matchPath<RouteParams>(state.router.location.pathname, {
    path: "/o/:pathOrganizationUuid/:extraPath?",
    strict: true,
  })?.params.pathOrganizationUuid;
